import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatService {
    /**
     * Subscribe Chat
     * Subscribe to all updates happening on a given chat.
     * @param chatId
     * @returns any Successful Response
     * @throws ApiError
     */
    static subscribeChat(chatId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/{chat_id}/subscribe',
            path: {
                'chat_id': chatId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add New Message To Chat
     * Post a new message to a chat.
     * @param chatId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static addNewMessageToChat(chatId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/{chat_id}',
            path: {
                'chat_id': chatId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chat
     * Get an existing chat.
     * @param chatId
     * @returns Chat Successful Response
     * @throws ApiError
     */
    static getChat(chatId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/{chat_id}',
            path: {
                'chat_id': chatId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Chat Message
     * Edit an existing chat message.
     * @param msgId
     * @param chatId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static editChatMessage(msgId, chatId, requestBody) {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/chat/{chat_id}/{msg_id}',
            path: {
                'msg_id': msgId,
                'chat_id': chatId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
